import React from 'react';
import { GridCardList } from './styles';

interface GridProps {
  lists: {
    title: string;
    slug: string;
  }[];
}
const GridCard = ({ lists }: GridProps) => {
  return (
    <div className="flex flex-wrap my-4 pt-6 tems-center sm:items-start">
      {lists.map((list) => (
        <div className="w-1/3 pb-4 pr-4 sm:w-1/2 sm:pb-2" key={list.title}>
          <a href={list.slug} className="text-font-500 text-s-14">
            <GridCardList>{list.title}</GridCardList>
          </a>
        </div>
      ))}
    </div>
  );
};

export default GridCard;
